import React from "react";
import { Button, CanvasAddPageIcon } from "@fluentui/react-northstar";
import pl from "shared/messages/pl";
import { constants } from "shared/constants";

export interface NotesListAddNewNoteButtonProps {
    onClick: () => void;
}

const NotesListAddNewNoteButton: React.FC<NotesListAddNewNoteButtonProps> = (props) => {
    return (
        <Button
            icon={<CanvasAddPageIcon styles={{ color: constants.actionIconColor }} />}
            text
            content={pl.view360Card.notes.notesList.addNewNote}
            onClick={props.onClick}
        />
    );
};

export default NotesListAddNewNoteButton;
